import { CLIENT_HOST } from 'src/config-global';
import { axiosInstance, endpoints } from 'src/utils/axios';

export type WhitelabelPaletteColor = {
  lighter?: string;
  light?: string;
  main: string;
  dark?: string;
  darker?: string;
  contrastText?: string;
};

export type WhitelabelPalette = {
  primary?: WhitelabelPaletteColor;
  secondary?: WhitelabelPaletteColor;
  info?: WhitelabelPaletteColor;
  success?: WhitelabelPaletteColor;
  warning?: WhitelabelPaletteColor;
  error?: WhitelabelPaletteColor;
  grey?: Record<string, string>;
  common?: { black: string; white: string };
  divider?: string;
  mode?: string;
};

export type WhitelabelConfig = {
  name: string;
  primaryColor: string;
  logoUrl: string;
  appBarLogoUrl: string;
  palette?: WhitelabelPalette;
};

// Default config; can be swapped per deployment/tenant
let whitelabelConfig: WhitelabelConfig = {
  name: 'Supermercados Manas',
  primaryColor: '#992C5B',
  logoUrl: '/logo/logo_manas_appbar.svg',
  appBarLogoUrl: '/logo/logo_manas_appbar.svg',
};

// Getter para acessar o whitelabel
export const getWhitelabel = (): WhitelabelConfig => whitelabelConfig;

// Mantém compatibilidade com código existente
export const whitelabel = new Proxy({} as WhitelabelConfig, {
  get: (target, prop) => getWhitelabel()[prop as keyof WhitelabelConfig],
});

// Função para buscar whitelabel do backend
export async function loadWhitelabel(): Promise<void> {
  try {
    const hostname = CLIENT_HOST || window.location.hostname;
    const response = await axiosInstance.get(endpoints.admin.whitelabel(hostname));
    const data = response.data.whitelabel;

    // Atualiza o whitelabel com os dados do backend
    whitelabelConfig = {
      name: data.name || whitelabelConfig.name,
      logoUrl: whitelabelConfig.logoUrl,
      appBarLogoUrl: whitelabelConfig.appBarLogoUrl,
      primaryColor: data.palette?.primary?.main || whitelabelConfig.primaryColor,
      palette: data.palette,
    };

    console.log('Whitelabel carregado do backend:', whitelabelConfig);
  } catch (error) {
    console.warn('Erro ao carregar whitelabel do backend, usando configuração padrão:', error);
    // Mantém a configuração padrão em caso de erro
  }
}
